/** @jsxImportSource react */
import * as Typeform from '@typeform/embed';
const { createWidget } = Typeform;
import { func, object, string } from 'proptypes';
import React, { useEffect, useRef, useState } from 'react';
import { isBrowser } from 'sly/config';

const TypeformWidget = ({ id, className, style = {}, ...props }) => {
  const [hiddenFields, setHiddenFields] = useState(props.hidden);
  // const { setDisableChatBot } = useChatbox();
  const container = useRef(null);

  // On click of retake button in ending screen, we will be redirected to our site with #embedded-section
  // So whenever we detect hashChange with #embedded-section,
  // Doing dummy state update to refresh typeform
  if (isBrowser) {
    window.addEventListener('hashchange', () => {
      const currentHash = window.location.hash;
      if (currentHash === '#embedded-section') {
        setHiddenFields({ ...hiddenFields });
      }
    });
  }

  // Whenever we have hash "'#embedded-section'", need to remove it from url
  // Adding logic to setTimeout to adding logic into to event queue, so on completion of refreshing typeform, url replacement logic will execute
  useEffect(() => {
    if (isBrowser && window.location.hash === '#embedded-section') {
      setTimeout(() => {
        history.pushState(
          '',
          document.title,
          window.location.pathname + window.location.search
        );
      }, 0);
    }
  }, [hiddenFields]);

  // useEffect(() => {
  //   if (container.current) {
  //     const intersectionObserver = new IntersectionObserver(
  //       (entries) => {
  //         let isIntersection = false;
  //         entries.forEach((entry) => {
  //           if (entry.isIntersecting) {
  //             isIntersection = true;
  //           }
  //         });
  //         if (isIntersection) {
  //           setDisableChatBot(true);
  //         } else {
  //           setDisableChatBot(false);
  //         }
  //       },
  //       {
  //         rootMargin: '0px 0px 500px 0px',
  //       }
  //     );
  //     intersectionObserver.observe(container.current);
  //     return () => intersectionObserver.disconnect();
  //   }
  //   return null;
  // }, [container, setDisableChatBot]);

  useEffect(() => {
    if (container.current) {
      const ref = createWidget(id, {
        ...props,
        container: container.current,
        onQuestionChanged: () => {
          window?.RokoInstabot?.close?.();
        },
      });
      return () => {
        ref.unmount();
      };
    }
  }, [id, props.onSubmit, hiddenFields]);

  return (
    <>
      <div
        style={style}
        className={className}
        ref={container}
        data-tp-id='gen-div-951a9b65-ad80-4a5c-885c-67317d30c54a'
      />
    </>
  );
};

TypeformWidget.propTypes = {
  id: string.isRequired,
  className: string,
  style: object,
  onSubmit: func,
};

export default TypeformWidget;
